import { c as _c } from "react/compiler-runtime";
import React, { useEffect } from 'react';
import { InstantSearch, Configure, useInstantSearch } from 'react-instantsearch';
import { searchClient } from 'components/essentials/AlgoliaSearchClient';
import GridWithSidebar from 'components/consumer/GridWithSidebar';
import { PhotoCardsResultSearch } from 'components/consumer/inspiration-photos-grid/search-state/utils';
import useFilters from 'components/consumer/inspiration-photos-grid/hooks/useFilters';
const DEFAULT_TABS_CONFIG = {
  products: true,
  productsTitle: ' ',
  productsHideLoadMore: true
};
const SearchSectionCountTracker = t0 => {
  const $ = _c(6);
  const {
    onCountChange
  } = t0;
  const {
    results
  } = useInstantSearch();
  let t1;
  if ($[0] !== onCountChange || $[1] !== results?.nbHits) {
    t1 = () => {
      const count = results?.nbHits;
      if (typeof onCountChange === "function" && Number.isFinite(count)) {
        onCountChange(count);
      }
    };
    $[0] = onCountChange;
    $[1] = results?.nbHits;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = results?.nbHits;
  let t3;
  if ($[3] !== onCountChange || $[4] !== t2) {
    t3 = [t2, onCountChange];
    $[3] = onCountChange;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  useEffect(t1, t3);
  return null;
};
const SearchCustomerPhotosContent = t0 => {
  const $ = _c(20);
  const {
    facetFilters,
    getCustomProps,
    hoveredValue,
    indexName,
    searchState,
    searchStateQuery,
    toggleReviewOnHover,
    updateSearchPage,
    onSectionCountChange
  } = t0;
  const {
    actions: filterActions
  } = useFilters();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["*"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== facetFilters || $[2] !== searchStateQuery) {
    t2 = <Configure query={searchStateQuery} hitsPerPage={9} facetFilters={facetFilters} facets={t1} numericFilters="" />;
    $[1] = facetFilters;
    $[2] = searchStateQuery;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== onSectionCountChange) {
    t3 = <SearchSectionCountTracker onCountChange={onSectionCountChange} />;
    $[4] = onSectionCountChange;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== filterActions || $[7] !== hoveredValue || $[8] !== toggleReviewOnHover || $[9] !== updateSearchPage) {
    t4 = t5 => {
      const {
        selectedGridItem,
        updateSelectedGridItem,
        showOnTop: t6
      } = t5;
      const showOnTop = t6 === undefined ? false : t6;
      return <PhotoCardsResultSearch filterActions={filterActions} hoveredValue={hoveredValue} onHoverHandler={toggleReviewOnHover} searchMore={updateSearchPage} selectedGridItem={selectedGridItem} showModalOnClick={true} showOnTop={showOnTop} updateSelectedGridItem={updateSelectedGridItem} />;
    };
    $[6] = filterActions;
    $[7] = hoveredValue;
    $[8] = toggleReviewOnHover;
    $[9] = updateSearchPage;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== getCustomProps || $[12] !== t4) {
    t5 = <div className="[&_.infinite-scroll-component]:flex [&_.infinite-scroll-component]:flex-row [&_.infinite-scroll-component]:items-start [&_.infinite-scroll-component]:flex-wrap [&_.infinite-scroll-component]:justify-between [&_.infinite-scroll-component]:min-w-full"><GridWithSidebar getCustomProps={getCustomProps} gridItemType="customer-photo" mobileItemsPerRow={1} naturalHeightImages={true} renderGrid={t4} tabsConfig={DEFAULT_TABS_CONFIG} variant="InspirationPage" /></div>;
    $[11] = getCustomProps;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== indexName || $[15] !== searchState || $[16] !== t2 || $[17] !== t3 || $[18] !== t5) {
    t6 = <div className="w-full"><InstantSearch searchClient={searchClient} searchState={searchState} indexName={indexName}>{t2}{t3}{t5}</InstantSearch></div>;
    $[14] = indexName;
    $[15] = searchState;
    $[16] = t2;
    $[17] = t3;
    $[18] = t5;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  return t6;
};
export default SearchCustomerPhotosContent;